<template>
    <div class="root_page_center wrapper_linkaccount wrapper_setting_bgr">
        <div class="row titleMenu">
            Liên kết tài khoản
        </div>
        <div class="wp_accountbank">
            <h3 class="title_dxcao">Đề xuất cao</h3>
            <div class="row">
                <div class="wp-accountbank--border" v-if="listBank && listBank.length">
                    <div class="col-md-4 col-sm-4 col-xs-4 wp_itemBank" v-for="(item, index) in listBank" :key="index">
                        <div class="itemBank">
                            <img :src="linkWebAdmin + item.image" alt="" @click="showMd(index)">
                            <img src="../assets/images/st.png" alt="" class="iconstar">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="wp_itemBank_edit">
            <div class="row">
                <div class="col-md-4 col-sm-4 col-xs-4 wp_itemBank" v-for="(item, index) in listBank1" :key="index">
                    <div class="itemBank">
                        <img :src="linkWebAdmin + item.image" alt="" @click="showMds()">
                    </div>
                </div>
            </div>
        </div>
        <div class="modalRedirect" v-if="showmodal">
            <div class="content_modalredirect">
                <p @click="showmodal = false" class="closeMdredirect"><img src="../assets/images/close.png" @click="showmodal = false" alt=""></p>
                <h3>Vui lòng cập nhật ứng dụng lên phiên bản mới nhất</h3>
                <router-link to="/bank-update">
                    <button type="button">Cập nhật ngay</button>
                </router-link>
                <router-link to="/bank" class="linkshortcut">&nbsp;</router-link>
                <p class="linkshortcutModal" @click="hideModalClick()">&nbsp;</p>
            </div>
        </div>
        <div class="modalRedirect" v-if="showmodals">
            <div class="content_modalredirect">
                <p @click="showmodals = false" class="closeMdredirect"><img src="../assets/images/close.png" @click="showmodals = false" alt=""></p>
                <h3 class="mg_bt_zr">Hiện tại ngân hàng đang bảo trì hệ thống sinh trác học. Vui lòng chọn ngân hàng khác để kê khai</h3>
            </div>
        </div>
        <div class="modalRedirect" v-if="showmodalUpdate">
            <div class="content_modalredirect">
                <p @click="showmodalUpdate = false" class="closeMdredirect"><img src="../assets/images/close.png" @click="showmodalUpdate = false" alt=""></p>
                <h3 class="textBalance">Cập nhật số dư</h3>
                <form action="" method="post" @submit="sendMoneyUpdate($event)">
                    <div class="inputUpdate">
                        <input type="text" v-model="showBalance" @input="onNumberInput">
                    </div>
                    <div class="inputUpdate">
                        <button>Cập nhật</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
export default {
    name: 'Linkaccount_tool',
    data() {
        return {
            token: window.localStorage.getItem('token'),
            listBank: [],
            listBank1: [],
            showmodal: false,
            showmodals: false,
            itemBank: [],
            showmodalUpdate: false,
            showBalance: '',
            balance: '',
        }
    },
    components: {

    },
    mounted() {

    },
    created() {
        this.getListBank()
        this.getListBank1()
    },
    computed: {

    },
    beforeUnmount() {

    },
    methods: {
        getListBank() {
            this.axios.get(this.api_logoBanks + '?status=1').then((response) => {
                this.listBank = response.data.data
            }).catch(e => {
                if (e.response.status == 401) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('idUser');
                    this.$swal({
                        position: 'top-end',
                        icon: 'error',
                        title: 'Kết thúc phiên đăng nhập',
                        showConfirmButton: false,
                        timer: 2000
                    })
                    setTimeout(() => {
                        window.location.href = '/'
                    }, 2000);
                }
            })
        },
        getListBank1() {
            this.axios.get(this.api_logoBanks + '?status=0').then((response) => {
                this.listBank1 = response.data.data
            })
        },
        showMd(index) {
            this.showmodal = true
            this.itemBank = this.listBank[index]
            window.localStorage.setItem('nameBank', this.itemBank.name)
            window.localStorage.setItem('title', this.itemBank.blue_text)
            window.localStorage.setItem('icon', this.itemBank.logo)
            window.localStorage.setItem('idbank', this.itemBank.id)
        },
        showMds() {
            this.showmodals = true
        },
        hideModalClick () {
            this.showmodal = false
            this.showmodalUpdate = true
            this.getDataBankOld()
        },
        getDataBankOld () {
            let idBank = window.localStorage.getItem('idbank')
            this.axios.get(this.api_bankMoney + '?bank_id=' + idBank,
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                this.showBalance = Number(response.data.data.money).toLocaleString('vi-VN')
                this.balance = response.data.data.money
            })
        },
        onNumberInput(e) {
            // const raw = e.target.value.replace(/,/g, '');
            const raw = e.target.value.replace(/\./g, '');
            this.balance = raw
            this.showBalance = this.formatNumber(raw);
        },
        formatNumber(value) {
            const cleaned = value.split('.')[0];
            const num = cleaned.replace(/\D/g, '');
            return num.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        },
        sendMoneyUpdate (e) {
            e.preventDefault()
            $('#loadingImg').show().fadeIn(10)
            this.axios.post(this.api_updateMoney, 
                {
                    bank_id: window.localStorage.getItem('idbank'),
                    balance: this.balance,
                    user_id: window.localStorage.getItem('idUser')
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                $('#loadingImg').css('display', 'none')
                // this.showmodalUpdate = false
                this.$swal({
                    position: 'top-end',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                })
            }).catch(e => {
                $('#loadingImg').css('display', 'none')
                this.$swal({
                    position: 'top-end',
                    icon: 'error',
                    title: e.response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                })
            })
        }
    }
}
</script>